import content from './sections/content';
import newsletter from './sections/newsletter';

const translations = {
    page: {
        metaTitle: 'Regulamin',
        metaDescription: 'Regulamin',
    },
    sections: {
        content,
        newsletter,
    },
};

export default translations;